import httpStore from "@/api/httpStore.js";

// Reembolsos de Placetopay (Costa Rica). A diferencia de Stripe (VUE_APP_WEB_API),
// van al API de la tienda seleccionada, que sirve web/Placetopay::admin_* en el
// host del admin. httpStore agrega el token y camelize la respuesta.

// Pago con lo reembolsado y el saldo reembolsable.
export function getPlacetopayPayment(orderNumber, paymentId) {
  return httpStore
    .get(`placetopay/admin_payment/${encodeURIComponent(paymentId)}`, {
      params: { order_number: orderNumber }
    })
    .then(res => res.data);
}

// Reembolso total (full=true) o parcial (amount). expectedRefundable es el saldo
// que mostró el modal: si ya no coincide el backend responde 409.
export function refundPlacetopayPayment(refund) {
  return httpStore
    .post("placetopay/admin_refund", {
      order_number: refund.orderNumber,
      payment_id: refund.paymentId,
      full: refund.full,
      amount: refund.amount,
      expected_refundable: refund.expectedRefundable,
      note: refund.note || "",
      idempotency_key: refund.idempotencyKey
    })
    .then(res => res.data);
}
